import styled from "styled-components"

export const Wrapper = styled.div`
    padding:10px;
    .title{
        margin:10px 0;
    }
`